import axios from 'axios';
import { V3_BASE_URL } from '@appmaker/core/api/core';

export const BACK_IN_STOCK_HANDLE = 'back-in-stock-by-appmaker';

// Read saved data on the server; do not forward an unsaved form snapshot.
export async function syncBackInStockSettings(projectId, handle) {
    if (handle !== BACK_IN_STOCK_HANDLE) return;
    try {
        const { data } = await axios.post(
            `${V3_BASE_URL}/projects/${projectId}/extension-functions/back-in-stock/sync-settings`,
            {}, { withCredentials: true }
        );
        if (data?.status !== true || data?.settingsSynced !== true) throw new Error('Unconfirmed sync');
    } catch {
        throw new Error('Settings are saved in Appmaker, but Back in Stock sync failed. Choose Save Changes again to retry.');
    }
}
